export const LOGINSIGNUPREQ = "LOGINSIGNUPREQ";
export const ADDAUSER = "ADDAUSER";
export const ISUSERLOGGED = "ISUSERLOGGED";